import { render } from "./Sliders.vue?vue&type=template&id=606c5bd0&scoped=true"
import script from "./Sliders.vue?vue&type=script&lang=js"
export * from "./Sliders.vue?vue&type=script&lang=js"

import "./Sliders.vue?vue&type=style&index=0&id=606c5bd0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606c5bd0"]])

export default __exports__